const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class Foray extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.Foray,
            "Each of the two strongest civilizations gains a total of 3 resource and/or food.",
            {}
        )
    }
}

module.exports = Foray;